import { motion } from "framer-motion";
import { COMPANY, IMG } from "../data";

const stats = [
  { value: "2021", label: "Opgericht" },
  { value: "3", label: "Afdelingen" },
  { value: "A–Z", label: "Fundament → afwerking" },
  { value: "1", label: "Hoofdaannemer" },
];

const reveal = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.8, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] } }),
};

export const About = () => {
  return (
    <section id="over" data-testid="about-section" className="max-w-[1600px] mx-auto px-6 md:px-10 py-24 md:py-40">
      <div className="grid md:grid-cols-12 gap-8 md:gap-12 items-start">
        <div className="md:col-span-5">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={reveal}
            className="flex items-center gap-4 mb-8"
          >
            <span className="h-px w-12 bg-[var(--orange)]" />
            <span className="font-mono-tech text-xs uppercase tracking-[0.25em] text-black/50">Over DOPMAN</span>
          </motion.div>

          <motion.h2
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={reveal}
            className="font-display text-4xl md:text-5xl font-medium tracking-tight leading-[1.02]"
          >
            Eén hoofdaannemer.<br />Van fundament tot <span className="text-[var(--turq)]">eindafwerking.</span>
          </motion.h2>

          <motion.p
            custom={1}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={reveal}
            className="mt-8 text-lg text-black/70 leading-relaxed max-w-md"
          >
            Sinds {COMPANY.since} realiseert DOPMAN B.V. complete bouwprojecten vanuit Voorschoten door heel Zuid-Holland en omstreken. Als hoofdaannemer nemen wij het volledige traject uit handen — van ontwerp en fundering tot de laatste laag verf.
          </motion.p>
          <motion.p
            custom={2}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={reveal}
            className="mt-5 text-lg text-black/70 leading-relaxed max-w-md"
          >
            Ons motto is niet toevallig <span className="italic text-black">“{COMPANY.motto}”</span> Met drie gespecialiseerde afdelingen zetten we voor elke fase de juiste vakmensen in.
          </motion.p>
        </div>

        <div className="md:col-span-7 md:pl-8">
          <motion.div
            initial={{ opacity: 0, scale: 1.05 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
            className="relative overflow-hidden border border-black/10"
          >
            <img src={IMG.about} alt="Modern bouwproject van DOPMAN" className="w-full h-[420px] md:h-[560px] object-cover" />
            <div className="absolute bottom-0 left-0 bg-[var(--ink)] text-white px-8 py-6 max-w-xs">
              <p className="font-mono-tech text-[10px] uppercase tracking-[0.2em] text-[var(--turq)] mb-2">Voorschoten · NL</p>
              <p className="font-display text-xl font-medium tracking-tight">Bouwen met oog voor detail en vakmanschap.</p>
            </div>
          </motion.div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-black/10 border border-black/10 border-t-0 mt-0">
            {stats.map((s, i) => (
              <motion.div
                key={s.label}
                custom={i}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={reveal}
                className="bg-[var(--bg)] p-6 md:p-8"
                data-testid={`stat-${i}`}
              >
                <div className="font-display text-3xl md:text-4xl font-semibold tracking-tight">{s.value}</div>
                <div className="font-mono-tech text-[10px] uppercase tracking-[0.15em] text-black/50 mt-2">{s.label}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
